import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffPriceListSuppliers = () => import('./staff/crudPriceListSuppliers')
const ViewStaffPriceListSuppliersImportLog = () => import('./staff/crudImportLog')
const ViewStaffPriceListSuppliersUpdateExternal = () => import('./staff/crudUpdateExternal')
const ViewStaffPriceListSuppliersImportEditor = () => import('./staff/crudImportEditor')
const ViewStaffProductSuppliersByBarcode = () => import('./staff/crudProductSuppliersByBarcode')

Vue.use(Router)

const router =
  [
    {
      path: '/st/costs',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'CostsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos de Productos por Proveedor',
          }
        },
        {
          path: 'configuration',
          name: 'CostsStaffConfiguration',
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Configuración',
          }
        },
        {
          path: 'price-list-suppliers',
          name: 'CostsStaffPriceListSuppliers',
          component: ViewStaffPriceListSuppliers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de productos por proveedor',
          }
        },      
        {
          path: 'price-list-suppliers-import-log',
          name: 'CostsStaffPriceListSuppliersImportLog',
          component: ViewStaffPriceListSuppliersImportLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Log de Importación',
          }                    
        },                
        {
          path: 'price-list-suppliers-import-editor',
          name: 'CostsStaffPriceListSuppliersImportEditor',
          component: ViewStaffPriceListSuppliersImportEditor,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Editor de Importación',
          }                    
        },                
        {
          path: 'price-list-suppliers-update-external',
          name: 'CostsStaffPriceListSuppliersUpdateExternal',
          component: ViewStaffPriceListSuppliersUpdateExternal,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Actualización Externa',
          }          
        },
        {
          path: 'product-suppliers-by-barcode',
          name: 'CostsStaffProductSuppliersByBarcode',
          component: ViewStaffProductSuppliersByBarcode,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Costos - Gestion de Productos',
          }
        },
      ]
    },

    {
      path: '/cu/costs',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/costs',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
